import { RefObject, useEffect, useRef, useState } from "react";

export function useScrollbarWidth(): [RefObject<HTMLDivElement>, number] {
  const divRef = useRef<HTMLDivElement>(null);

  const [scrollbarWidth, setScrollbarWidth] = useState<number>(0);

  useEffect(() => {
    const divRefElement = divRef.current;
    if (divRefElement) {
      if (divRefElement.clientHeight < divRefElement.scrollHeight) {
        setScrollbarWidth(divRefElement.offsetWidth - divRefElement.clientWidth);
      }
    }
  }, [setScrollbarWidth]);

  return [divRef, scrollbarWidth];
}
